<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title">
      <div>
        <label class="p-d-flex p-jc-center">地方創生SDGs官民連携プラットフォーム</label>
        <label class="p-d-flex p-jc-center title-name">
          <label *ngIf="information">運営事務局からのお知らせ</label>
          <label *ngIf="!information">会員主催イベント・お知らせ</label>
        </label>
      </div>
    </div>
    <!-- 本文 -->
    <div>
      <label *ngIf="information">運営事務局より、ウェブサイトの更新やプラットフォーム主催のイベント等についてお知らせします。</label>
      <div class="p-d-flex p-jc-center">
        <label *ngIf="!information">会員の皆様の主催によるイベント・お知らせについて情報発信します。<br />
          ※各会員主催イベント・お知らせ等について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。</label>
      </div>
    </div>

    <!-- お知らせ -->
    <div class="notice" *ngIf="information">
      <p-tabView>
        <p-tabPanel header="お知らせ">
          <ng-container *ngTemplateOutlet="noticeList; context: { information_kbn: 1 }"></ng-container>
        </p-tabPanel>
        <p-tabPanel header="プラットフォーム主催イベント">
          <ng-container *ngTemplateOutlet="noticeList; context: { information_kbn: 2 }"></ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div class="notice" *ngIf="!information">
      <p-tabView>
        <ng-container *ngTemplateOutlet="membreEvent;"></ng-container>
      </p-tabView>
    </div>
  </div>
</div>

<!-- お知らせ,プラットフォーム主催イベント リスト -->
<ng-template #noticeList let-information_kbn="information_kbn">
  <!-- お知らせ区分を判定-->
  <p-dataView [value]="1 == information_kbn ? noticeDataList : platformEventDataList" emptyMessage="データが存在しません">
    <!-- 1:お知らせの場合、noticeDataListを使用 -->
    <!-- 2:PF主催イベントの場合、platformEventDataListを使用 -->
    <ng-template let-noticeData pTemplate="listItem">
      <div class="p-col-12">
        <!-- 一覧アイテム-->
        <div class="list-data" [value]="noticeData.url" onClick="window.open(this.value)">
          <!-- 掲載開始日 -->
          <div class="list-date">
            {{ noticeData.publishe_start }}
          </div>
          <!-- 見出し -->
          <div class="list-heading">
            {{ noticeData.head }}
          </div>
          <!-- タイトル -->
          <div class="list-title">
            {{ noticeData.title }}
          </div>
        </div>
      </div>
    </ng-template>
  </p-dataView>
</ng-template>

<!-- 会員主催イベント リスト -->
<ng-template #membreEvent let-event_kbn="event_kbn">
  <p-dataView [value]="memberEventInformationDataList" emptyMessage="データが存在しません">
    <ng-template let-memberEventData pTemplate="listItem">
      <div class="p-col-12">
        <!-- 一覧アイテム-->
        <a class="list-data" [attr.href]="'pages/platform/e102/' + memberEventData.member_event_id" target="_blank">
          <!-- 掲載日 -->
          <div class="list-date-pf">
            {{ memberEventData.status.date }}
          </div>
          <!-- 区分 -->
          <div class="list-kbn-pf">
            <p-tag value="イベント" styleClass="event-tag" *ngIf="1 == memberEventData.event_kbn.id"></p-tag>
            <p-tag value="お知らせ" styleClass="information-tag" *ngIf="2 == memberEventData.event_kbn.id"></p-tag>
            <p-tag value="お知らせ" styleClass="information-tag" *ngIf="3 == memberEventData.event_kbn.id"></p-tag>
            <p-tag value="イベント" styleClass="event-tag" *ngIf="4 == memberEventData.event_kbn.id"></p-tag>
          </div>
          <!-- 申請団体名 -->
          <div class="list-org-pf">
            {{ memberEventData.organization_name }}
          </div>
          <!-- タイトル -->
          <div class="list-title-pf">
            {{ memberEventData.title + (memberEventData?.is_subcommittee_data ? " : " + memberEventData?.theme : "") }}
          </div>
        </a>
      </div>
    </ng-template>
  </p-dataView>
</ng-template>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
